var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKyc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 335,
    viewBox: "0 0 343 335",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M194.355 209.505L198.364 175.748L209.312 183.967L229.975 114.252L242.156 160.925L259.889 154.32L248.17 180.298L194.355 209.505Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3098 231.177H14.1805",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5521 246.643H21.4153",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8736 231.624L16.9531 266.968",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6295 231.624L63.709 266.968",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M247.636 180.221L198.731 204.668C161.514 198.335 140.906 164.317 158.745 145.614C170.741 133.096 151.21 114.393 139.214 126.911C123.22 143.699 117.991 167.998 127.68 189.058C136.446 208.055 156.592 220.72 177.969 222.045C178.892 222.045 179.661 222.193 180.583 222.193L206.881 208.939L251.173 186.701L247.636 180.221Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M157.468 33.2149L126.953 48.5212L192.603 168.534L223.117 153.228L157.468 33.2149Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M223.561 147.382L187.325 165.558L191.749 173.646L227.985 155.47L223.561 147.382Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M141.44 18.8841L123.867 27.6989L140.494 58.0936L158.067 49.2788L141.44 18.8841Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M186.128 110.269C193.049 122.787 187.974 138.25 174.902 144.877C161.83 151.504 145.682 146.644 138.761 134.127C129.995 118.075 136.916 106.146 149.988 99.5189C163.06 92.8919 179.208 97.7517 186.128 110.269Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M172.429 117.193C175.351 122.494 173.198 128.974 167.662 131.625C162.125 134.423 155.358 132.361 152.59 127.059C148.899 120.285 151.821 115.278 157.358 112.627C162.74 109.976 169.507 111.891 172.429 117.193Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M206.882 258.863C207.189 252.383 205.805 245.756 202.422 239.571C192.272 220.868 168.127 213.8 148.75 223.519C133.986 230.882 124.451 242.958 126.45 258.863H206.882Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M253.019 253.705H104.766V266.959H253.019V253.705Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M189.197 255.623C189.351 251.941 188.582 248.26 186.736 244.872C181.046 234.416 167.513 230.44 156.593 235.889C148.289 240.013 142.906 246.787 144.137 255.77",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M189.197 255.623C189.351 251.941 188.582 248.26 186.736 244.872C181.046 234.416 167.513 230.44 156.593 235.889C148.289 240.013 142.906 246.787 144.137 255.77",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M192.425 82.879L307.152 49.5967C307.152 49.5967 401.424 203.638 279.008 251.941C179.045 291.409 168.742 319.979 156.746 334.116L31.5617 294.207C31.5617 294.207 57.5521 234.859 144.75 206.141C231.949 177.424 219.492 141.344 192.425 82.879Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M136.292 307.902L61.0891 283.898",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M119.373 289.053C101.38 283.309 83.3863 277.566 65.3929 271.822",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M140.594 295.828C135.981 294.355 131.367 292.882 126.753 291.41",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M299.153 116.898C301.152 116.309 303.151 115.72 305.151 115.131",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M252.248 130.446C265.32 126.617 278.393 122.788 291.465 119.106",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M273.159 138.103C284.539 135.6 295.766 133.243 307.146 130.74",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M253.172 142.375C257.324 141.491 261.476 140.608 265.628 139.724",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M239.329 127.65L248.557 103.351L265.781 108.358L287.619 71.9827",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M309.681 195.556L264.407 175.277L243.23 218.631L288.504 238.91L309.681 195.556Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M231.948 234.712L218.26 219.691L249.941 193.036L263.782 208.057L231.948 234.712Z",
    fill: "url(#paint1_linear)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M244.715 248.7L233.795 236.771L255.787 218.363L266.706 230.291L244.715 248.7Z",
    fill: "url(#paint2_linear)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M159.36 294.945L149.671 290.527L159.052 271.677L168.741 276.095L159.36 294.945Z",
    fill: "url(#paint3_linear)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M147.673 289.642L137.984 285.224L145.366 270.35L155.055 274.768L147.673 289.642Z",
    fill: "url(#paint4_linear)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M168.433 299.067L160.744 295.532L167.203 282.573L174.892 286.107L168.433 299.067Z",
    fill: "url(#paint5_linear)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M153.359 9.24695L161.972 1",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M155.671 19.1103L175.202 13.6614",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M258.086 170.061L252.242 176.393",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M189.191 195.097L191.345 198.338",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M265.626 185.376L269.472 189.206",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M271.935 205.845V211.883",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M275.32 195.098L280.704 193.036",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9494 229.707L1.2644 201.284C1.2644 201.284 24.0252 187.294 30.7919 182.581C37.5586 177.869 48.0163 200.106 48.0163 200.106L24.0252 216.6C23.8714 216.453 28.0237 225.289 20.9494 229.707Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8702 216.452L24.3316 209.531",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2543 211.887L27.4058 213.654",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M76.926 230.884L41.2469 230.737C41.2469 230.737 41.7083 204.818 41.2469 196.866C40.9394 188.913 66.007 192.89 66.007 192.89L66.9297 221.165C66.9297 221.165 76.926 222.638 76.926 230.884Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8663 213.507H68.9324C68.3172 184.938 66.318 146.795 65.549 118.226C65.2415 103.793 64.7801 89.3613 64.6263 74.9291C64.3187 62.8532 64.1649 50.1882 70.3165 39.2905C78.7749 24.2692 54.9376 11.0152 46.4792 25.8892C32.023 51.5136 37.0981 83.6178 37.7132 111.746C38.4822 142.377 39.2511 182.729 39.8663 213.507Z",
    fill: "black"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7793 46.8021C69.549 39.7333 60.4754 35.7571 53.8625 37.5243C46.0193 39.586 42.9435 46.6548 44.1738 53.7236C51.0943 93.0439 66.627 158.136 22.7971 185.528C22.6433 185.675 22.4895 185.675 22.3358 185.822C26.6418 193.627 31.2555 201.138 36.023 208.796C36.1768 208.648 36.4844 208.501 36.6381 208.354C60.6292 193.48 80.3143 167.414 83.5438 140.758C87.2348 109.832 76.1619 77.2863 70.7793 46.8021Z",
    fill: "black"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9343 221.165L61.0903 216.894",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5507 220.725L66.473 216.748",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4818 171.093C47.4023 162.404 65.088 132.214 40.9431 55.4879",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9443 204.078C48.942 200.396 62.3217 185.522 65.3975 181.84",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M128.143 6.45162C130.45 8.36609 132.142 11.0169 132.142 14.5513C129.066 14.9931 124.299 13.0786 122.761 11.9005C121.223 10.7224 119.531 12.6368 120.146 14.1095C120.761 15.4349 116.609 14.9931 115.84 14.5513C115.533 14.404 115.225 14.1095 114.917 13.9622C115.071 11.7532 116.455 9.54423 119.531 7.33522C119.993 6.89342 120.608 6.45162 121.377 5.86255C123.53 5.86255 125.837 6.15709 128.143 6.45162Z",
    fill: "black"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M119.53 7.33528C116.762 9.39702 115.378 11.606 115.07 13.6678L95.2314 12.1951L97.9996 20.8838L118.915 22.2092C122.913 25.5964 127.22 22.062 127.22 22.062L129.373 22.651C129.373 22.651 131.526 20.0002 132.141 14.6986C132.756 9.24975 125.682 2.62273 119.53 7.33528Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M99.846 16.7582C96.3088 4.68227 85.3898 -4.59556 42.944 24.416C52.6327 34.2829 62.4752 44.0026 72.3177 53.7222C79.5458 50.1878 89.3883 45.6225 95.5399 43.119C105.998 38.9955 103.383 28.245 99.846 16.7582Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M151.056 48.5657C158.592 46.7985 162.898 43.8531 165.051 45.9149C167.204 47.9766 158.13 49.5965 160.745 51.2165C163.359 52.8364 168.434 49.1547 169.818 52.1001C171.048 55.0454 162.129 56.6654 162.129 56.6654C162.129 56.6654 170.279 54.1618 171.202 56.2236C172.125 58.2853 162.59 61.967 162.59 61.967C162.59 61.967 170.741 59.0216 172.125 61.5252C173.355 64.0287 164.743 65.9432 155.977 69.4776",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M151.056 48.5657C158.592 46.7985 162.898 43.8531 165.051 45.9149C167.204 47.9766 158.13 49.5965 160.745 51.2165C163.359 52.8364 168.434 49.1547 169.818 52.1001C171.048 55.0454 162.129 56.6654 162.129 56.6654C162.129 56.6654 170.279 54.1618 171.202 56.2236C172.125 58.2853 162.59 61.967 162.59 61.967C162.59 61.967 170.741 59.0216 172.125 61.5252C173.355 64.0287 164.743 65.9432 155.977 69.4776",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7782 19.1121C63.5508 37.9622 72.0092 59.7578 91.0791 69.4774C111.533 79.9333 134.448 75.5153 155.517 69.6247C153.825 62.5558 152.287 55.6343 150.903 48.5655C137.831 52.3944 123.375 56.6652 109.688 53.4253C99.5375 51.069 84.1586 40.1712 92.7708 24.4137",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7782 19.1121C63.5508 37.9622 72.0092 59.7578 91.0791 69.4774C111.533 79.9333 134.448 75.5153 155.517 69.6247C153.825 62.5558 152.287 55.6343 150.903 48.5655C137.831 52.3944 123.375 56.6652 109.688 53.4253C99.5375 51.069 84.1586 40.1712 92.7708 24.4137",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M141.678 51.3639L146.907 71.9813",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M149.056 64.1763L149.518 67.1223",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 227.122,
    y1: 114.252,
    x2: 227.122,
    y2: 209.505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4B740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4B740",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 241.021,
    y1: 193.036,
    x2: 241.021,
    y2: 234.712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4B740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4B740",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 250.251,
    y1: 218.363,
    x2: 250.251,
    y2: 248.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4B740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4B740",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 159.206,
    y1: 271.677,
    x2: 159.206,
    y2: 294.945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4B740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4B740",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 146.52,
    y1: 270.35,
    x2: 146.52,
    y2: 289.642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4B740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4B740",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 167.818,
    y1: 282.573,
    x2: 167.818,
    y2: 299.067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4B740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4B740",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKyc);
export default __webpack_public_path__ + "static/media/kyc.6a3685c6bd731738077d77e1e0615e7a.svg";
export { ForwardRef as ReactComponent };